import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText,
} from '../../../components/warehouses-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>รหัสคลังสินค้า</HeaderLabel>,
    accessor: 'warehouseCode',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อคลังสินค้า</HeaderLabel>,
    accessor: 'warehouseName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 350,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>จังหวัด</HeaderLabel>,
    accessor: 'address.district',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
